import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map } from 'rxjs/operators';
import { PracticeSetupStepValidation } from './practice-setup-step-validation';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/medical-history'],
  validationMode: 'any',
};

export const medicalHistoryAlertsStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.MedicalHistoryAlerts,
  category: PracticeSetupStepCategory.Miscellaneous,
  title: 'Configure Medical Conditions, Allergies and the Medical History Form',
  description: initRawSchema([
    toParagraphContent(
      `Principle's digital Medical History Form can be sent to patients to complete before their appointment, reducing in-office paperwork. Customise the default form to your practice's needs using the drag-and-drop editor.`
    ),
    toParagraphContent(
      `If migrating from a compatible PMS, existing medical conditions and allergies can be mapped directly to fields on Principle's Medical History Form.`
    ),
  ]),
  dependsOn: [],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/medical-history`,
  validate$: (practice$, step, options) => {
    return practice$.pipe(
      map((_practice) => {
        if (options?.reviewed || options?.skipped) {
          return { valid: true };
        }

        const pageVisitValidation =
          PracticeSetupStepValidation.validatePageVisits(
            step,
            pageVisitTracking
          );
        if (pageVisitValidation.valid) {
          return { valid: true };
        }

        return {
          valid: false,
          reason:
            'Please review the medical alerts before completing this step',
        };
      })
    );
  },
  pageVisitTracking,
};
